/**
 * created by mleitzell on 1/4/18.
 * Gets the formatted string for the user agent passed to the formatUserAgent function or uses the current user agent if no agent is passed
 * if mobile: os browser (device) i.e. iOS Safari (Mobile) or Android Chrome (Tablet)
 * if desktop: browser (Desktop) i.e. Chrome (Desktop)
 * if unsupported, display the full user agent string
 */
import locale from "common/managers/locale";

/**
 * List of supported browser keys
 * The key will match the object key from the kendo.support.browser object
 * @type {string[]}
 */
var BROWSER_KEYS = [
    "chrome",
    "edge",
    "mozilla",
    "msie",
    "safari"
];

export default {

    /**
     * Get the string representing the OS and the browser
     * @param userAgent {string} The user agent string to format or undefined to use the current system
     */
    formatUserAgent: function(userAgent) {
        var mobile = this._getMobileDetail(userAgent);
        var browser = this._getBrowserDetail(userAgent);
        var osKey, browserKey, deviceKey;
        if (mobile) {
            osKey = this._getOsKey(mobile);
            if (!osKey) {
                return userAgent;
            }
            browserKey = this._getBrowserKey(browser);
            if (!browserKey) {
                return userAgent;
            }
            deviceKey = this._getDeviceKey(mobile);
            return locale.get("user.agent.format.mobile",
                locale.get("user.agent.os." + osKey),
                locale.get("user.agent.browser." + browserKey),
                locale.get("user.agent.device." + deviceKey));
        }
        browserKey = this._getBrowserKey(browser);
        if (!browserKey) {
            return userAgent;
        }
        return locale.get("user.agent.format.desktop", locale.get("user.agent.browser." + browserKey));
    },

    /**
     * Get the mobile detail of the user agent
     * @param userAgent {string} The user agent string to format or undefined to use the current system
     * @returns {object} The kendo.support.mobileOS data object
     * @private
     */
    _getMobileDetail: function(userAgent) {
        return userAgent !== undefined ? kendo.support.detectOS(userAgent) : kendo.support.mobileOS;
    },

    /**
     * Get the browser detail of the user agent
     * @param userAgent {string} The user agent string to format or undefined to use the current system
     * @returns {object} The kendo.support.browser data object
     * @private
     */
    _getBrowserDetail: function(userAgent) {
        return userAgent !== undefined ? kendo.support.detectBrowser(userAgent) : kendo.support.browser;
    },

    /**
     * Get the OS for a mobile user agent
     * Only returns data if the user agent is mobile
     * @param detail {{name: string}} The kendo support.mobileOS user agent data
     * @private
     */
    _getOsKey: function(detail) {
        if (detail.name === "ios" || detail.name === "android") {
            return detail.name;
        }
    },

    /**
     * Get the browser of the user agent
     * @param detail {object} The kendo support.browser user agent data
     * @private
     */
    _getBrowserKey: function(detail) {
        for (var i = 0; i < BROWSER_KEYS.length; i++) {
            if (detail[BROWSER_KEYS[i]]) {
                return BROWSER_KEYS[i];
            }
        }
    },

    /**
     * Get the device (mobile or tablet) for the mobile user agent
     * @param detail {{tablet: string}} The kendo support.mobileOS user agent data
     * @private
     */
    _getDeviceKey: function(detail) {
        if (!detail.tablet) {
            return "mobile";
        }
        return "tablet";
    }
};
